import Session from '@/util/session';

const apiUrl = process.env.VUE_APP_API_URL || process.env.BASE_URL || '';
const preApiUrl = process.env.VUE_APP_PRE_API_URL || '';

export function getBaseUrl() {
    let account = Session.getAccount(), company = account ? account.defaultCompany : null;
    // 灰度测试环境
    if (company && company.dcName == 'pre') {
        return preApiUrl || apiUrl;
    }
    return apiUrl;
}